"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPullWireImport = exports.PullWireImportSchema = void 0;
const tslib_1 = require("tslib");
const echain_shared_i18n_1 = require("@igus/echain-shared-i18n");
const echain_prisma_client_1 = require("@igus/echain-prisma-client");
const zod_1 = require("zod");
const PullWireSchema_1 = tslib_1.__importDefault(require("../../generated/zod/modelSchema/PullWireSchema"));
const ArticleType_1 = require("../ArticleType");
const Mantelwerkstoff_1 = require("../Mantelwerkstoff");
exports.PullWireImportSchema = PullWireSchema_1.default.extend({
    articleType: zod_1.z.custom((a) => a === ArticleType_1.ArticleType.leitung, { message: 'invalid ArticleType' }),
    // JSON fields => LocalizedText's
    artNr: zod_1.z.custom(echain_shared_i18n_1.isLocalizedText, { message: 'invalid LocalizedText' }),
    categories: zod_1.z.nativeEnum(echain_prisma_client_1.ChainflexCategory).array().nonempty(),
    crossSection: zod_1.z.custom(echain_shared_i18n_1.isLocalizedText, { message: 'invalid LocalizedText' }),
    description: zod_1.z.custom(echain_shared_i18n_1.isLocalizedText, { message: 'invalid LocalizedText' }),
    mainCategory: zod_1.z.nativeEnum(echain_prisma_client_1.ChainflexCategory),
    outerJacket: zod_1.z.nativeEnum(Mantelwerkstoff_1.Mantelwerkstoff),
    akeneoUuid: zod_1.z
        .string()
        .nullish()
        .transform((x) => x !== null && x !== void 0 ? x : undefined)
        .optional(),
});
const isPullWireImport = (whatever) => {
    var _a;
    return (_a = exports.PullWireImportSchema.safeParse(whatever)) === null || _a === void 0 ? void 0 : _a.success;
};
exports.isPullWireImport = isPullWireImport;
//# sourceMappingURL=PullWireImport.js.map